import { AnimatePresence } from "framer-motion";
import { cloneElement } from "react";
import { useOutlet } from "react-router-dom";

/**
 * A react-router outlet for animating in a drawer on route changes.
 *
 * The key is fixed to ensure the drawer doesn't slide up-and-down when switching out the inner
 * content within a drawer (ie. selected different steps).
 */
export const DrawerOutlet = () => {
  const element = useOutlet();

  return (
    <AnimatePresence initial={false}>
      {element && cloneElement(element, { key: `drawer` })}
    </AnimatePresence>
  );
};
